'use client'


import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styles from './style.module.css';
import './style.css';
import { Affix, Col, DatePicker, Input, Row, Select, Spin } from 'antd';
import { FilterDateSelector, FiltersBottomSheet, formatMsg, Helper, MobileFilterButton, permissions, PrefixIconButton, SpinWrapper, timeutil, wrapperComponents } from 'sharedresources';
import { AttendanceStatus } from 'sharedresources/src/types/attendance';
import { SearchOutlined } from "@ant-design/icons";
import AttendanceMobileCard from './AttendanceMobileCard';
const { TableWrapper } = wrapperComponents;



interface EntityAttedanceProps {
    entityType: 'INSTRUCTOR' | 'PARTICIPANT';
    entityColumns: any[];
    entityData: any[];
    centersMap: Map<string, any>;
    packagesMap: Map<string, any>;
    dateRange: any;
    setDateRange: any;
    selectedRowKeys: any;
    setSelectedRowKeys: any;
    editMode: any;
    batchesMap: any;
    attendanceMap: any;
    attendanceSettings: any;
    usersMap: any;
    onCancel: any;
    onSubmit: any;
    accountsMap?: any;
};


const EntityAttendance = (props: EntityAttedanceProps) => {


    const { entityType, entityColumns, entityData, centersMap, packagesMap, dateRange, setDateRange, selectedRowKeys, setSelectedRowKeys, editMode, onCancel, onSubmit, batchesMap, usersMap, attendanceMap, attendanceSettings, accountsMap } = props;
    const { firebase, attendanceReducer, multicenterReducer, packageReducer, accountReducer } = Helper.getSelectorState(['attendanceReducer', 'multicenterReducer', 'packageReducer', 'accountReducer']);

    const [entitySearch, setEntitySearch] = useState(undefined);
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);


    const [centerFilter, setCenterFilter] = useState(undefined);
    const [packageFilter, setPackageFilter] = useState(undefined);
    const [batchFilter, setBatchFilter] = useState(undefined);
    const [statusFilter, setStatusFilter] = useState(undefined);
    const [participantFilter, setParticipantFilter] = useState(undefined);
    const [timeSlotFilter, setTimeSlotFilter] = useState(undefined);

    const [filteredBatchList, setFilteredBatchList] = useState(undefined);
    const [filteredTimeSlotList, setFilteredTimeSlotList] = useState(undefined);

    const [showFiltersBottomSheet, setShowFiltersBottomSheet] = useState(false);
    const [appliedFiltersCount, setAppliedFiltersCount] = useState(0);


    const [list, setList] = useState([]);


    const isTeacherLoggedIn = Helper.getLoggedInUserType(firebase).toLowerCase() === "teacher";


    useEffect(() => {
        let newBatchList = (!packageFilter || packageFilter.length === 0)
            ? packageReducer.batchList
            : packageReducer.batchList?.filter((obj) => packageFilter.includes(obj.packageId))
        setFilteredBatchList(newBatchList);
    }, [packageReducer.batchList, packageFilter])


    useEffect(() => {
        let newTimeSlotList = (!batchFilter || batchFilter.length === 0)
            ? filteredBatchList
            : filteredBatchList?.filter((obj) => batchFilter.includes(obj.id));

        const uniqueKeys = new Set<string>();

        newTimeSlotList?.forEach(batch => {
            batch.intervals.forEach(interval => {
                const key = `${timeutil.getInstance(interval.startTime).format("hh:mm A")} - ${timeutil.getInstance(interval.endTime).format("hh:mm A")}`;
                uniqueKeys.add(key);
            });
        });

        setFilteredTimeSlotList(Array.from(uniqueKeys));
    }, [filteredBatchList, batchFilter]);


    const filteredAttendanceStats = useMemo(() => {

        const stats = { pending: 0, present: 0, absent: 0, pendingCheckin: 0, pendingCheckout: 0 };

        (list || []).forEach((obj: any) => {
            const hasPermission = permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.ATTENDANCE_VIEW, [obj.centerId]);
            if (!hasPermission) return;

            const dateSlotCenterEntityKey = `${timeutil.inFormat(obj.date, 'DD-MM-YY')}--${obj.slotRandomId}--${obj.centerId}--${entityType === "INSTRUCTOR" ? obj.staffId : obj.profileId}`;

            const displayAttendanceObj = attendanceMap.get(dateSlotCenterEntityKey);
            const attendanceStatus: AttendanceStatus = Helper.getAttendanceStatus(displayAttendanceObj);

            if (attendanceStatus === 'PENDING' || attendanceStatus === 'CLEARED') stats.pending++;
            else if (attendanceStatus === 'PRESENT') stats.present++;
            else if (attendanceStatus === 'ABSENT') stats.absent++;

            if (attendanceStatus !== 'ABSENT' && typeof (displayAttendanceObj?.latestCheckIn) !== 'number') stats.pendingCheckin++;
            if (attendanceStatus !== 'ABSENT' && typeof (displayAttendanceObj?.latestCheckOut) !== 'number') stats.pendingCheckout++;
        });

        return stats;

    }, [list, attendanceMap, entityType]);


    const stickerList = useMemo(() => {
        if (attendanceSettings?.type === "checkin_checkout") {
            return [
                {
                    imgSrc: "/images/present.png",
                    label: formatMsg('totalPresents'),
                    stickerVal: filteredAttendanceStats?.present || 0
                },
                {
                    imgSrc: "/images/absent.png",
                    label: formatMsg('totalAbsent'),
                    stickerVal: filteredAttendanceStats?.absent || 0
                },
                {
                    imgSrc: "/images/checkInPending.png",
                    label: formatMsg('pendingCheckin'),
                    stickerVal: filteredAttendanceStats?.pendingCheckin || 0
                },
                {
                    imgSrc: "/images/checkOutPending.png",
                    label: formatMsg('pendingCheckout'),
                    stickerVal: filteredAttendanceStats?.pendingCheckout || 0
                }
            ];
        }

        return [
            {
                imgSrc: "/images/present.png",
                label: formatMsg('totalPresents'),
                stickerVal: filteredAttendanceStats?.present || 0
            },
            {
                imgSrc: "/images/absent.png",
                label: formatMsg('totalAbsent'),
                stickerVal: filteredAttendanceStats?.absent || 0
            },
            {
                imgSrc: "/images/yellowExclaimation.png",
                label: formatMsg('pending'),
                stickerVal: filteredAttendanceStats?.pending || 0
            }
        ];

    }, [attendanceSettings, filteredAttendanceStats]);


    function getUrlParam() {

        let dateStr = Helper.getUrlParam(`${entityType}_date`);
        let epoch = dateStr ? parseInt(dateStr, 10) : null;
        if (Number.isFinite(epoch) && epoch > 0) {
            setDateRange([
                epoch,
                timeutil.getInstance(epoch).endOf("day").valueOf()
            ]);
        } else {
            setDateRange([
                timeutil.getInstance().startOf("day").valueOf(),
                timeutil.getInstance().endOf("day").valueOf()
            ]);
        }

        const pageNo = Helper.getUrlParam(`${entityType}_pageNo`);
        pageNo && setPageNo(Number(pageNo));

        const pageSize = Helper.getUrlParam(`${entityType}_pageSize`);
        pageSize && setPageSize(Number(pageSize));

        let packageFilterJSONString = Helper.getUrlParam(`${entityType}_packageFilter`);
        let packageFilterParsedJSON = packageFilterJSONString ? JSON.parse(packageFilterJSONString) : undefined;
        if (packageFilterParsedJSON) setPackageFilter(packageFilterParsedJSON);

        let centerFilterJSONString = Helper.getUrlParam(`${entityType}_centerFilter`);
        let centerFilterParsedJSON = centerFilterJSONString ? JSON.parse(centerFilterJSONString) : undefined;
        if (centerFilterParsedJSON) setCenterFilter(centerFilterParsedJSON);


        let batchFilterJSONString = Helper.getUrlParam(`${entityType}_batchFilter`);
        let batchFilterParsedJSON = batchFilterJSONString ? JSON.parse(batchFilterJSONString) : undefined;
        if (batchFilterParsedJSON) setBatchFilter(batchFilterParsedJSON);

        let statusFilterJSONString = Helper.getUrlParam(`${entityType}_statusFilter`);
        let statusFilterParsedJSON = statusFilterJSONString ? JSON.parse(statusFilterJSONString) : undefined;
        if (statusFilterParsedJSON) setStatusFilter(statusFilterParsedJSON);

        let timeSlotFilterJSONString = Helper.getUrlParam(`${entityType}_timeSlotFilter`);
        let timeSlotFilterParsedJSON = timeSlotFilterJSONString ? JSON.parse(timeSlotFilterJSONString) : undefined;
        if (timeSlotFilterParsedJSON) setTimeSlotFilter(timeSlotFilterParsedJSON);

        let participantFilterJSONString = Helper.getUrlParam(`${entityType}_participantFilter`);
        let participantFilterParsedJSON = participantFilterJSONString ? JSON.parse(participantFilterJSONString) : undefined;
        if (participantFilterParsedJSON) setParticipantFilter(participantFilterParsedJSON);
    }

    useEffect(() => {
        getUrlParam();
    }, []);

    useEffect(() => {
        filterList();
    }, [entityData, entitySearch, statusFilter, packageFilter, batchFilter, centerFilter, timeSlotFilter, participantFilter]);

    useEffect(() => {
        if (dateRange?.length === 2) {
            Helper.setUrlParam(`${entityType}_date`, timeutil.getEpoch(dateRange[0]))
        }
    }, [dateRange])

    function doesStatusMatch(
        attendance: any,
        attendanceStatus: string,
        selectedStatuses: any
    ): boolean {

        if (!selectedStatuses.size) return true;

        const normalizedStatus = attendanceStatus?.toLowerCase();
        const conditions: boolean[] = [];


        if (selectedStatuses.has('present') || selectedStatuses.has('absent') || selectedStatuses.has('pending')) {
            conditions.push(selectedStatuses.has(normalizedStatus));
        }

        if (selectedStatuses.has('pendingcheckin')) {
            conditions.push(typeof attendance?.latestCheckIn !== 'number');
        }

        if (selectedStatuses.has('pendingcheckout')) {
            conditions.push(typeof attendance?.latestCheckOut !== 'number');
        }

        if (selectedStatuses.has('latecheckin')) {
            conditions.push(Boolean(attendance?.lateIn));
        }

        if (selectedStatuses.has('latecheckout')) {
            conditions.push(Boolean(attendance?.lateOut));
        }

        return conditions.some(Boolean);
    }


    function filterList() {

        let statusesSet = new Set();
        if (statusFilter?.length) {
            statusFilter.forEach((status) => statusesSet.add(status.toLowerCase()));
        }

        let selectedCentersSet = new Set();
        if (centerFilter?.length) selectedCentersSet = new Set(centerFilter);

        let selectedPackagesSet = new Set();
        if (packageFilter?.length) selectedPackagesSet = new Set(packageFilter);

        let selectedBatchesSet = new Set();
        if (batchFilter?.length) selectedBatchesSet = new Set(batchFilter);

        let selectedTimeSlotsSet = new Set();
        if (timeSlotFilter?.length) selectedTimeSlotsSet = new Set(timeSlotFilter);

        let selectedParticipantsSet = new Set();
        if (participantFilter?.length) selectedParticipantsSet = new Set(participantFilter);

        let list = entityData?.filter((obj) => {

            const tempName = entitySearch?.toLowerCase();

            const searchMatch = !entitySearch || (obj && (
                usersMap.get(entityType === "INSTRUCTOR" ? obj.staffId : obj.profileId).name.toLowerCase().includes(tempName)
            ));

            const dateSlotCenterEntityKey = `${timeutil.inFormat(obj.date, 'DD-MM-YY')}--${obj.slotRandomId}--${obj.centerId}--${entityType === "INSTRUCTOR" ? obj.staffId : obj.profileId}`;
            const attendance = attendanceMap.get(dateSlotCenterEntityKey);
            const attendanceStatus: AttendanceStatus = Helper.getAttendanceStatus(attendance);

            const statusMatch = doesStatusMatch(attendance, attendanceStatus, statusesSet);


            const packageMatch = !packageFilter?.length || selectedPackagesSet.has(obj.packageId);

            const batchMatch = !batchFilter?.length || selectedBatchesSet.has(obj.batchId);

            const centerMatch = !centerFilter?.length || (obj.centerId && selectedCentersSet.has(obj.centerId));

            const timeSlotMatch = !timeSlotFilter?.length || selectedTimeSlotsSet.has(`${timeutil.getInstance(obj.startTime).format("hh:mm A")} - ${timeutil.getInstance(obj.endTime).format("hh:mm A")}`);

            const participantMatch = !participantFilter?.length || selectedParticipantsSet.has(obj.profileId);

            const hasPermission = permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.ATTENDANCE_VIEW, [obj.centerId]);

            return searchMatch && statusMatch && packageMatch && batchMatch && centerMatch && timeSlotMatch && participantMatch && hasPermission;
        })

        setList(list);
    }


    const handlePageChange = useCallback((newPageNo, newPageSize) => {

        setPageNo(newPageNo);
        setPageSize(newPageSize);

        Helper.setUrlParam(`${entityType}_pageNo`, newPageNo ? newPageNo : 1);
        Helper.setUrlParam(`${entityType}_pageSize`, newPageSize ? newPageSize : 10);

    }, [setPageNo, setPageSize]);


    const handlePackageFilterChange = useCallback((packageFilterVal) => {

        const isAllSelected: boolean = packageFilterVal?.some((val) => val === 'all packages') || false;

        if (packageReducer.packageList && isAllSelected) {
            packageFilterVal = packageReducer.packageList.map((item) => item.id);
        }

        let stringifiedData = packageFilterVal ? JSON.stringify(packageFilterVal) : '';

        setPackageFilter(packageFilterVal);
        setBatchFilter(null);
        Helper.setUrlParam(`${entityType}_packageFilter`, stringifiedData);

    }, [setPackageFilter, packageReducer.packageList]);


    const handleBatchFilterChange = useCallback((batchFilterVal) => {

        const isAllSelected: boolean = batchFilterVal?.some((val) => val === 'all batches') || false;

        if (filteredBatchList && isAllSelected) {
            batchFilterVal = filteredBatchList.map((item) => item.id);
        }

        let stringifiedData = batchFilterVal ? JSON.stringify(batchFilterVal) : '';

        setBatchFilter(batchFilterVal);
        Helper.setUrlParam(`${entityType}_batchFilter`, stringifiedData);

    }, [setBatchFilter, filteredBatchList]);

    const handleCenterFilterChange = useCallback((centerFilterVal) => {

        const isAllSelected: boolean = centerFilterVal?.some((val) => val === 'all centers') || false;

        if (multicenterReducer.allCentersList && isAllSelected) {
            centerFilterVal = multicenterReducer.allCentersList.map((item) => item.id);
        }

        let stringifiedData = centerFilterVal ? JSON.stringify(centerFilterVal) : '';

        setCenterFilter(centerFilterVal);
        Helper.setUrlParam(`${entityType}_centerFilter`, stringifiedData);

    }, [setCenterFilter, multicenterReducer.allCentersList]);

    const handleTimeSlotFilterChange = useCallback((timeSlotFilterVal) => {

        const isAllSelected: boolean = timeSlotFilterVal?.some((val) => val === 'all time slots') || false;

        if (filteredTimeSlotList && isAllSelected) {
            timeSlotFilterVal = filteredTimeSlotList;
        }

        let stringifiedData = timeSlotFilterVal ? JSON.stringify(timeSlotFilterVal) : '';

        setTimeSlotFilter(timeSlotFilterVal);
        Helper.setUrlParam(`${entityType}_timeSlotFilter`, stringifiedData);

    }, [setTimeSlotFilter, filteredTimeSlotList]);

    const handleStatusFilterChange = useCallback((statusFilterVal) => {

        const isAllSelected: boolean = statusFilterVal?.some((val) => val === 'all status') || false;
        const statusOptions = getStatusOptions();
        if (attendanceSettings && statusOptions && isAllSelected) {
            statusFilterVal = statusOptions;
        }

        let stringifiedData = statusFilterVal ? JSON.stringify(statusFilterVal) : '';

        setStatusFilter(statusFilterVal);
        Helper.setUrlParam(`${entityType}_statusFilter`, stringifiedData);

    }, [setStatusFilter, attendanceSettings]);

    const handleParticipantFilterChange = useCallback((participantFilterVal) => {

        const isAllSelected: boolean = participantFilterVal?.some((val) => val === 'all participants') || false;

        if (accountReducer.accountUsersList && isAllSelected) {
            participantFilterVal = accountReducer.accountUsersList.map((item) => item.id);
        }

        let stringifiedData = participantFilterVal ? JSON.stringify(participantFilterVal) : '';

        setParticipantFilter(participantFilterVal);
        Helper.setUrlParam(`${entityType}_participantFilter`, stringifiedData);

    }, [setParticipantFilter, accountReducer.accountUsersList]);

    const [filterNameToFilterMetaDataObjMap, setFilterNameToFilterMetaDataObjMap] = useState(
        getFilterNameToFilterMetaDataObjMapForView()
    );

    function getFilterNameToFilterMetaDataObjMapForView() {

        const newFilterNameToFilterMetaDataObjMap = new Map();

        newFilterNameToFilterMetaDataObjMap.set('filterLabel.packages', {
            optionsArr: packageReducer.packageList || [],
            selectedVal: packageFilter,
            setSelectedVal: handlePackageFilterChange,
            showAllOption: false,
            filterType: 'multiSelect'
        });

        newFilterNameToFilterMetaDataObjMap.set('filterLabel.batches', {
            optionsArr: filteredBatchList || [],
            selectedVal: batchFilter,
            setSelectedVal: handleBatchFilterChange,
            showAllOption: false,
            filterType: 'multiSelect'
        });

        newFilterNameToFilterMetaDataObjMap.set('filterLabel.timeslots', {
            optionsArr: filteredTimeSlotList || [],
            selectedVal: timeSlotFilter,
            setSelectedVal: handleTimeSlotFilterChange,
            showAllOption: false,
            filterType: 'multiSelect'
        });

        newFilterNameToFilterMetaDataObjMap.set('filterLabel.status', {
            optionsArr: getStatusOptions() || [],
            selectedVal: statusFilter,
            setSelectedVal: handleStatusFilterChange,
            showAllOption: false,
            filterType: 'multiSelect'
        });

        newFilterNameToFilterMetaDataObjMap.set('filterLabel.participants', {
            optionsArr: accountReducer.accountUsersList || [],
            selectedVal: participantFilter,
            setSelectedVal: handleParticipantFilterChange,
            showAllOption: false,
            filterType: 'multiSelect'
        });

        return newFilterNameToFilterMetaDataObjMap;
    }

    useEffect(() => {
        setFilterNameToFilterMetaDataObjMap(
            getFilterNameToFilterMetaDataObjMapForView()
        );
    }, [accountReducer.accountUsersList, participantFilter, handleParticipantFilterChange, timeSlotFilter, filteredTimeSlotList, batchFilter, filteredBatchList, handleBatchFilterChange, handleTimeSlotFilterChange, packageReducer.packageList, packageFilter, handlePackageFilterChange, statusFilter, attendanceSettings, handleStatusFilterChange]);

    const onRowSelection = (selectedRowKeys) => {
        setSelectedRowKeys(selectedRowKeys);
    }

    function getStatusOptions() {

        const baseStatuses = ['absent', 'present'];

        if (attendanceSettings?.type !== 'checkin_checkout') {
            baseStatuses.push('pending')
            return baseStatuses;
        }

        const checkinStatuses = ['pendingCheckIn', 'pendingCheckOut'];

        if (attendanceSettings?.enableLateCheckInTracking) {
            checkinStatuses.push('lateCheckin');
        }

        if (attendanceSettings?.enableLateCheckOutTracking) {
            checkinStatuses.push('lateCheckout');
        }

        return [...baseStatuses, ...checkinStatuses];
    }


    const isLoading = attendanceReducer.isLoading || attendanceReducer.attendanceLoading || packageReducer.isLoading || multicenterReducer.isLoading || accountReducer.isLoading;
    const isAccount = Helper.isAccount(firebase);

    return (
        <div>
            <Row className={`${styles.filterRow} ${isAccount ? styles.mobileView : ''}`} gutter={[15, 10]}>
                <Col xxl={4} xl={4} lg={6} md={12} sm={12} xs={24}>
                    <Input
                        placeholder={
                            entityType === "INSTRUCTOR"
                                ? formatMsg(`search.${entityType}`)
                                : Helper.getSelectedUserTypeName(firebase, formatMsg("searchUsers"), formatMsg('search'), null, "LOWERCASE")
                        }
                        value={entitySearch}
                        onChange={(e) => {
                            e.preventDefault();
                            setEntitySearch(e.target.value);
                        }}
                        suffix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                    />
                </Col>
                <Col xxl={4} xl={4} lg={6} md={12} sm={12} xs={24}>
                    <Select
                        mode='multiple'
                        onChange={handlePackageFilterChange}
                        maxTagCount={0}
                        maxTagPlaceholder={Helper.getFilterMaxTagPlaceholder('package', packageFilter, packagesMap)}
                        style={{ width: "100%" }}
                        placeholder={formatMsg("sidebar.packages")}
                        value={packageFilter}
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => Helper.filterOptionByChildren(input, option)}
                    >
                        {/* <Select.Option
                            key={"all"}
                            value={"all packages"}
                        >
                            {formatMsg("caps.allPackages")}
                        </Select.Option> */}
                        {
                            (isAccount ? packageReducer.packageList || [] : packageReducer.packageNames || [])?.map((item) => {
                                const hasPermission = permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.ATTENDANCE_VIEW, item.centerIds);
                                if (!hasPermission) return;
                                return (
                                    <Select.Option key={item.id} value={item.id}>
                                        {item.name}
                                    </Select.Option>
                                )
                            })
                        }
                    </Select>
                </Col>
                <Col xxl={4} xl={4} lg={6} md={12} sm={12} xs={24}>
                    <Select
                        disabled={!packageFilter?.length}
                        mode='multiple'
                        onChange={handleBatchFilterChange}
                        maxTagCount={0}
                        maxTagPlaceholder={Helper.getFilterMaxTagPlaceholder('batch', batchFilter, batchesMap)}
                        style={{ width: "100%" }}
                        placeholder={formatMsg("batches")}
                        value={batchFilter}
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => Helper.filterOptionByChildren(input, option)}
                    >
                        {/* <Select.Option
                            key={"all"}
                            value={"all batches"}
                        >
                            {formatMsg("caps.allBatches")}
                        </Select.Option> */}
                        {
                            filteredBatchList?.map((item) => {
                                return (
                                    <Select.Option key={item.id} value={item.id}>
                                        {item.name}
                                    </Select.Option>
                                )
                            })
                        }
                    </Select>
                </Col>
                <Col xxl={3} xl={3} lg={6} md={12} sm={12} xs={24}>
                    <Select
                        mode='multiple'
                        onChange={handleTimeSlotFilterChange}
                        maxTagCount={0}
                        maxTagPlaceholder={Helper.getFilterMaxTagPlaceholder('timeSlot', timeSlotFilter)}
                        style={{ width: '100%' }}
                        value={timeSlotFilter}
                        placeholder={formatMsg('timeSlots')}
                        popupMatchSelectWidth={false}
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => Helper.filterOptionByChildren(input, option)}
                    >
                        {/* <Select.Option
                            key={"all"}
                            value={"all time slots"}
                        >
                            {formatMsg("allTimeSlots")}
                        </Select.Option> */}
                        {
                            filteredTimeSlotList?.map((item, idx) => {
                                return (
                                    <Select.Option key={idx} value={item}>
                                        {item}
                                    </Select.Option>
                                )
                            })
                        }
                    </Select>
                </Col>
                {
                    isTeacherLoggedIn &&
                    <Col xxl={3} xl={3} lg={8} md={12} sm={12} xs={24}>
                        <Select
                            mode='multiple'
                            onChange={handleCenterFilterChange}
                            maxTagCount={0}
                            maxTagPlaceholder={Helper.getFilterMaxTagPlaceholder('center', centerFilter, centersMap)}
                            style={{ width: '100%' }}
                            value={centerFilter}
                            placeholder={formatMsg('centers')}
                            menuItemSelectedIcon={null}
                            popupMatchSelectWidth={false}
                            allowClear
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) => Helper.filterOptionByChildren(input, option)}
                        >
                            {/* <Select.Option
                                key={"all"}
                                value={"all centers"}
                            >
                                {formatMsg("allCenters")}
                            </Select.Option> */}
                            {
                                multicenterReducer.allCentersList?.map((item) => {
                                    return (
                                        <Select.Option key={item.id} value={item.id}>
                                            {item.name}
                                        </Select.Option>
                                    )
                                })
                            }
                        </Select>
                    </Col>
                }
                <Col xxl={3} xl={3} lg={8} md={12} sm={12} xs={24}>
                    <DatePicker
                        allowClear={false}
                        value={dateRange[0] ? timeutil.getInstance(dateRange[0]) : null}
                        onChange={date => {
                            if (date) {
                                setDateRange([
                                    timeutil.getInstance(date).startOf("day").valueOf(),
                                    timeutil.getInstance(date).endOf("day").valueOf()
                                ]);
                            } else {
                                setDateRange([null, null]);
                            }
                        }}
                        disabledDate={(current) => {
                            return current && current > timeutil.getInstance().endOf("day");
                        }}
                        placeholder={formatMsg("placeholder.selectDate")}
                        size="large"
                        style={{
                            height: isTeacherLoggedIn ? "36px" : "32px",
                            width: "100%",
                        }}
                        format={Helper.dateFormat(firebase)}
                        popupClassName='attn-today-btn'
                    />

                </Col>
                <Col xxl={3} xl={3} lg={8} md={12} sm={12} xs={24}>
                    <Select
                        mode='multiple'
                        onChange={handleStatusFilterChange}
                        maxTagCount={0}
                        maxTagPlaceholder={Helper.getFilterMaxTagPlaceholder('status', statusFilter)}
                        style={{ width: '100%' }}
                        value={statusFilter}
                        placeholder={formatMsg('statuses')}
                        popupMatchSelectWidth={false}
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => Helper.filterOptionByChildren(input, option)}
                    >
                        {
                            [...getStatusOptions()]?.map((status, idx) => {
                                return (
                                    <Select.Option key={idx} value={status}>
                                        {formatMsg(status)}
                                    </Select.Option>
                                )
                            })
                        }
                    </Select>
                </Col>
                {
                    !isTeacherLoggedIn &&
                    <Col xxl={3} xl={3} lg={8} md={12} sm={12} xs={24}>
                        <Select
                            mode='multiple'
                            maxTagCount={0}
                            maxTagPlaceholder={Helper.getFilterMaxTagPlaceholder('participant', participantFilter, usersMap)}
                            onChange={handleParticipantFilterChange}
                            style={{ width: "100%" }}
                            placeholder={
                                formatMsg(
                                    "selectParticipant",
                                    {
                                        Participant: Helper.getSelectedUserTypeName(
                                            firebase,
                                            formatMsg('participant')
                                        )
                                    }
                                )
                            }
                            value={participantFilter}
                            allowClear
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) => Helper.filterOptionByChildren(input, option)}
                        >
                            {
                                [...accountReducer.accountUsersList].map((item) => {
                                    return (
                                        <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                                    )
                                })
                            }
                        </Select>
                    </Col>
                }
            </Row>

            <div className={`${styles.stickerRow} ${isAccount ? styles.mobileView : ''}`}>
                {
                    stickerList.map((stickerObj) => {
                        return (
                            <div className={styles.stickerContainer}>
                                <div className={styles.stickerFirstHalf}>
                                    <div className={styles.imgContainer}>
                                        <img
                                            src={stickerObj.imgSrc}
                                            className={styles.attendanceIcon}
                                        />
                                    </div>
                                    <div className={styles.stickerLabel}>
                                        {stickerObj.label}
                                    </div>
                                </div>
                                <div className={styles.stickerSecondHalf}>
                                    <span className={styles.attendanceStats}>
                                        {stickerObj.stickerVal}
                                    </span>
                                </div>
                            </div>
                        )
                    })
                }
            </div>

            <div className={`${styles.editContainer} ${isAccount ? styles.mobileView : ''}`}>
                <img
                    className={styles.actionImg}
                    src='/images/present.png'
                />
                <div className="attn-icon-indication">
                    {attendanceSettings?.type === "checkin_checkout" ? formatMsg("checkInCheckOut") : formatMsg("present")}
                </div>
                <img
                    className={styles.actionImg}
                    src='/images/absent.png'
                />
                <div className="attn-icon-indication">
                    {formatMsg("absent")}
                </div>
                <img
                    className={styles.actionImg}
                    src='/images/yellowExclaimation.png'
                />
                <div className="attn-icon-indication">
                    {formatMsg("pending")}
                </div>
                {
                    editMode &&
                    <Col span={2}>
                        <PrefixIconButton
                            title={formatMsg('cancel')}
                            width={'100%'}
                            height={'40px'}
                            border={true}
                            fontColor={'var(--primary-color)'}
                            borderColor={`1px solid var(--primary-color)`}
                            borderRadius={'8px'}
                            onClick={() => onCancel(entityType)}
                        />
                    </Col>
                }
                {
                    editMode &&
                    <Col span={2}>
                        <PrefixIconButton
                            type='primary'
                            title={formatMsg('save')}
                            width={'100%'}
                            height={'40px'}
                            border={true}
                            borderColor={`1px solid var(--primary-color)`}
                            borderRadius={'8px'}
                            onClick={() => onSubmit(entityType)}
                        />
                    </Col>
                }
            </div>

            {
                isAccount &&
                <div className='mobile-attendance-filters-row'>
                    <div className='mob-attendance-search-filter-container'>
                        <Input
                            placeholder={
                                entityType === "INSTRUCTOR"
                                    ? formatMsg(`search.${entityType}`)
                                    : Helper.getSelectedUserTypeName(firebase, formatMsg("searchUsers"), formatMsg('search'), null, "LOWERCASE")
                            }
                            value={entitySearch}
                            onChange={(e) => {
                                e.preventDefault();
                                setEntitySearch(e.target.value);
                            }}
                            suffix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                        />
                    </div>

                    <div className='mob-attendance-date-picker-row'>
                        <DatePicker
                            allowClear={false}
                            value={dateRange[0] ? timeutil.getInstance(dateRange[0]) : null}
                            onChange={date => {
                                if (date) {
                                    setDateRange([
                                        timeutil.getInstance(date).startOf("day").valueOf(),
                                        timeutil.getInstance(date).endOf("day").valueOf()
                                    ]);
                                } else {
                                    setDateRange([null, null]);
                                }
                            }}
                            disabledDate={(current) => {
                                return current && current > timeutil.getInstance().endOf("day");
                            }}
                            placeholder={formatMsg("placeholder.selectDate")}
                            size="large"
                            style={{
                                height: "36px",
                                width: "100%",
                            }}
                            format={Helper.dateFormat(firebase)}
                            popupClassName='attn-today-btn'
                        />

                        <MobileFilterButton
                            setShowFiltersBottomSheet={setShowFiltersBottomSheet}
                            appliedFiltersCount={appliedFiltersCount}
                            btnContCss={'inv-mob-filter-btn'}
                        />
                    </div>
                </div>
            }

            <div className={`${isAccount ? styles.mobileView : ""}`}>
                <TableWrapper
                    rowKey={(record) => {

                        const dateSlotCenterEntityBatchPackageStartTimeEndTimeKey = `${timeutil.inFormat(record.date, 'DD-MM-YY')}-$-${record.slotRandomId}-$-${record.centerId}-$-${entityType === 'PARTICIPANT' ? record.profileId : record.staffId}-$-${record.batchId}-$-${record.packageId}-$-${record.startTime}-$-${record.endTime}-$-${record.bookingId}`;
                        return dateSlotCenterEntityBatchPackageStartTimeEndTimeKey;
                    }}
                    columns={entityColumns}
                    dataSource={list}
                    {...(isTeacherLoggedIn 
                        ? {
                            rowSelection: {
                                selectedRowKeys,
                                onChange: onRowSelection,
                                getCheckboxProps: (record) => {
                                    let shouldDisable = !permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.ATTENDANCE_MARK, [record.centerId]);
                                    return {
                                        disabled: shouldDisable,
                                    };
                                },
                            },
                        }
                        : {})}
                    scroll={{ x: 1200, y: 715 }}
                    pagination={{
                        current: pageNo,
                        pageSize: pageSize,
                        onChange: handlePageChange,
                        showSizeChanger: true,
                        hideOnSinglePage: false
                    }}
                    loading={isLoading}
                    sticky
                />
            </div>
            {
                isAccount &&
                <Spin spinning={isLoading}>
                    <div className='attendance-list-view'>
                        {list?.map((listObj) => (
                            <AttendanceMobileCard
                                attendanceObj={listObj}
                                firebase={firebase}
                                participantsMap={usersMap}
                                packagesMap={packagesMap}
                                centersMap={centersMap}
                                participantsAttendanceMap={attendanceMap}
                            />
                        ))}
                    </div>
                </Spin>
            }



            <div className={styles.bottomSheet}>
                <FiltersBottomSheet
                    firebase={firebase}
                    filterNameToFilterMetaDataObjMap={filterNameToFilterMetaDataObjMap}
                    showFiltersBottomSheet={showFiltersBottomSheet}
                    setShowFiltersBottomSheet={setShowFiltersBottomSheet}
                    setAppliedFiltersCount={setAppliedFiltersCount}
                />
            </div>
        </div >
    )
}

export default EntityAttendance